import React, { useState } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import Button from "./components/Button";
import TransitionBlock from "./components/TransitionBlock";
import * as Const from "./_Const";
/*
    public static final int PAGE_ID_INSERT_CARD = 2;
    public static final int PAGE_ID_BUTTONS = 1;    
    public static final int PAGE_ID_DOCTORS = 4;   
    public static final int PAGE_ID_TOP_NESTED = 6;
    public static final int PAGE_ID_REMOVE_CARD = 3;
    
*/

const PAGE_ID_TOP_NESTED = 6;
const PAGE_ID_DOCTORS = 4;
const PAGE_ID_BUTTONS = 1;

function PageButtons() {
  const [number, setNumber] = useState(1);
  const { getButtonsData, currentBtnPageIndex, navigateNextButtons, selectedButtonId, getPageData } = useFormCtx();
  const index = Const.REG_01_INDEX;

  const page = getPageData(index);

  const buttonsData = getButtonsData();
  const noNestingData = getButtonsFilter(PAGE_ID_BUTTONS);
  const firstNestingData = getButtonsFilter(PAGE_ID_DOCTORS);
  const secondNestingData = getButtonsFilter(PAGE_ID_TOP_NESTED);
  const isTerminal = Const.isTerminal();
  const textCss = isTerminal ? "text-lg mt-3" : "text-sm mt-4";

  function getButtonsFilter(page) {
    return buttonsData ? buttonsData.filter((item) => item.pageId === page) : null;
  }

  function getButtonsFind(data, id) {
    return data ? data.find((item) => item.doctorId === id) : null;
  }

  function getData() {
    let data = null;
    if (secondNestingData && secondNestingData.length > 0) {
      log("6 exists");
      if (currentBtnPageIndex == 0) {
        data = secondNestingData;
      } else if (currentBtnPageIndex == 1) {
        data = getButtonsFind(firstNestingData, selectedButtonId);
      } else if (currentBtnPageIndex == 2) {
        data = getButtonsFind(noNestingData, selectedButtonId);
      }
    } else {
      log("6 not exists");
      if (firstNestingData && firstNestingData.length > 0) {
        log("4 exists");
        if (currentBtnPageIndex == 0) {
          data = firstNestingData;
        } else if (currentBtnPageIndex == 1) {
          data = getButtonsFind(noNestingData, selectedButtonId);
        }
      } else {
        log("4 not exists");
        if (noNestingData && noNestingData.length > 0) {
          log("1 exists");
          if (currentBtnPageIndex == 0) {
            data = noNestingData;
          }
        } else {
          log("1 not exists");
        }
      }
    }

    if (data && data.length === 1) {
      data = data[0];
    }
    //console.log(data);
    return data;
  }

  function log(text) {
    // console.log(text);
  }

  function getTestData() {
    const source = {
      title: "Důvod návštěvy",
      subtitle: "Zvolte důvod návštěvy",
      buttons: [
        {
          id: 1,
          order: 1,
          queueId: 1005,
          text: "Vyšetření",
          /*text: "Administrativan\nVýpis z dok.\nLístek na peníze",*/
        },
        {
          id: 2,
          order: 2,
          queueId: 1044,
          text: "Recept",
        },
        {
          id: 3,
          order: 3,
          queueId: 1043,
          text: "Kontrola",
        },
        {
          id: 4,
          order: 4,
          queueId: 1045,
          text: "Administrativa",
        },
        {
          id: 5,
          order: 5,
          queueId: 1046,
          text: "Ostatní",
        },
        {
          id: 6,
          order: 6,
          queueId: 1047,
          text: "Produktivita",
        },
        {
          id: 7,
          order: 7,
          queueId: 1048,
          text: "Injekce",
        },
        {
          id: 8,
          order: 8,
          queueId: 1049,
          text: "Lístek na peníze",
        },

        {
          id: 9,
          order: 9,
          queueId: 1050,
          text: "Jsem objednán(a)",
        },
        {
          id: 10,
          order: 10,
          queueId: 1051,
          text: "Recepty, Kontrola krev. tlaku",
        },
      ],
    };

    console.log(number);

    const filtered = source.buttons.filter((i, index) => index < number);

    return { ...source, buttons: filtered };
  }

  let data = getData(); //getData();
  //console.log(data);

  //data = data.slice(0, number);

  let showSubtitle = data?.buttons?.length >= 8 ? false : true;
  const showTitle = !Const.isTerminal();
  if (showSubtitle && !showTitle) {
    showSubtitle = false;
  }

  //const text = "Přednostní vyšetření text a";
  function canWrapTitle(title) {
    let canWrap = false;

    const len = title?.length ?? 0;
    // console.log(len);

    if (len > 25) {
      canWrap = true;
    }
    // console.log(title, len, canWrap);
    return canWrap;
  }

  function handleClick(params) {
    if (number === 10) {
      setNumber(1);
    } else {
      setNumber(number + 1);
    }
  }

  function getFormatClass() {
    const count = data?.buttons?.length ?? 0;
    // console.log(count);

    let className = "flex flex-col space-y-4";
    let framerCss;
    let buttonCss;
    let showInfo = true;
    if (Const.isTerminal()) {
      switch (count) {
        case 2:
          buttonCss = "h-[33vh] text-6xl";
          break;
        case 3:
          buttonCss = "h-[22vh] text-5xl";
          break;
        case 4:
          buttonCss = "h-[16vh] text-4xl";
          break;
        case 5:
          framerCss = "first:col-span-2";
          className = "grid grid-cols-2 gap-4 self-center items-center";
          buttonCss = "h-[22vh] text-4xl";
          break;
        case 6:
          className = "grid grid-cols-2 gap-4 self-center items-center";
          buttonCss = "h-[22vh] text-4xl";
          break;
        case 7:
          framerCss = "first:col-span-2";
          className = "grid grid-cols-2 gap-4 self-center items-center";
          buttonCss = "h-[16vh] text-4xl";
          break;
        case 8:
          className = "grid grid-cols-2 gap-4 self-center items-center";
          buttonCss = "h-[16vh] text-3xl";
          break;
        case 9:
          framerCss = "first:col-span-2";
          className = "grid grid-cols-2 gap-4 self-center items-center";
          buttonCss = "h-[105px] text-3xl";
          showInfo = false;
          break;
        case 10:
          className = "grid grid-cols-2 gap-4 self-center items-center";
          buttonCss = "h-[105px] text-3xl";
          showInfo = false;
          break;
      }
    } else {
      //na terminalu nepoustet PING jen na mobilu - je to hodne vytezujici procesor 20-30% i teplotu
      buttonCss = "ping";
    }
    return { css: className, buttonCss, framerCss, showInfo };
  }
  const { css, buttonCss, framerCss, showInfo } = getFormatClass();

  const delay = isTerminal ? 0 : 0.01;

  return (
    <>
      {data && (
        <PageWrapper title={data.title} index={index} showTitle={showTitle}>
          {showSubtitle && <h2 className="mt-6 text-xl font-light text-primary mx-6">{data.subtitle}</h2>}
          <div className={`mt-4 mx-6 ${css}`}>
            {data &&
              data.buttons &&
              data.buttons.map((item, aIndex) => (
                <TransitionBlock key={item.id} delay={delay * aIndex} className={` ${framerCss}`}>
                  <Button
                    className={`w-full h-16a ${buttonCss}`}
                    key={item.id}
                    title={item.text}
                    canWrap={canWrapTitle(item.text)}
                    showIcon={item.queueId == 0}
                    /*onClick={handleClick}*/
                    onClick={() => navigateNextButtons(item, index)}
                  />
                </TransitionBlock>
              ))}
          </div>

          {showInfo && <p className={`${textCss} mx-6  text-secondary font-light`}>Kliknutím na jedno z tlačítek přejdete na další obrazovku</p>}
        </PageWrapper>
      )}
    </>
  );
}

export default PageButtons;
